export function LocationDepartmentTypeFactory() {
    return function LocationDepartmentType() {
        return {
            id: null,
            name: ''
        };
    };
}
